import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { ModalEl } from "common/components/modal";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { SpinnerEl } from "common/components/spinner";
import { TextHighlightEl } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { TagInputEl } from "common/components/tag-input";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { ShareOptionsLocation, SharingModalViewType } from "common/widgets/sharing/modal/types";
import { pluralize, truncate } from "common/util/string";
import { BannerEl } from "common/components/banner";
import { BannerAction, BannerTheme, BannerType } from "common/components/banner/types";
import { ButtonEl } from "common/components/button";
import { SwitchEl } from "common/components/switch";
import { TableEl } from "common/components/table";
import { LoadingStatus } from "common/widgets/sharing/types";
import { LinkDetailMixin } from "common/templates/public-dashboards/mixins";
import { Placement } from "common/components/tooltip/types";
import { currentProjectStore } from "common/report/stores/project-details";
import { SvgIconEl } from "common/components/svg-icon";
import TableStyle from "./public-links-table.inline.styl";
import { ShareSection } from "./helpers";
const PublicDashboardDetailsView = ({
  state,
  helpers,
  showSuperadminBanner
}) => {
  return /* @__PURE__ */ jsx("div", {
    sel: ".wrapper",
    class: { "no-min-height": helpers.shouldShowUpsellBanner() }
  }, /* @__PURE__ */ jsx("header", {
    sel: ".modal-header"
  }, "Public Board Details"), /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, showSuperadminBanner ? /* @__PURE__ */ jsx(BannerEl, {
    style: { "margin-bottom": `20px` },
    attrs: {
      "body-text": `You have not been granted access to edit this Board, but as a Project Owner you can make changes.`,
      theme: BannerTheme.Info,
      type: BannerType.Embedded
    }
  }) : null, /* @__PURE__ */ jsx("p", {
    sel: ".public-dashboard-disclaimer"
  }, "Non Project members can access a ", /* @__PURE__ */ jsx("strong", null, "read-only"), " instance of a Public Board with a link. ", /* @__PURE__ */ jsx("br", null), "Learn more about Public Boards on our Help docs."), state.publicDashboardLinks.loading === LoadingStatus.Success ? /* @__PURE__ */ jsx("div", {
    sel: ".banner-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".color-indicator"
  }), /* @__PURE__ */ jsx("p", null, "This Board ", /* @__PURE__ */ jsx("b", null, '"', helpers.getEntityName(), '"'), " has ", state.publicDashboardLinks.data.length, " active Public", ` `, pluralize(`URL`, state.publicDashboardLinks.data.length, `URLs`))) : null, /* @__PURE__ */ jsx(TableEl, {
    sel: ".mp-table",
    attrs: {
      elref: `publicDashboardLinksTable`,
      "empty-message": `No public board URLs`,
      "style-override": TableStyle,
      "track-name": `Public Dashboard Links`,
      "window-scroll": true,
      "max-body-height": `450px`,
      "disable-clickable-rows": true,
      "disable-expandable-rows": true,
      loading: state.publicDashboardLinks.loading === LoadingStatus.Pending
    },
    props: {
      rows: helpers.publicDashboard.getPublicDashboardLinksTableRows(),
      columns: helpers.publicDashboard.getPublicDashboardLinksTableCols(),
      rowDetailsRenderer: LinkDetailMixin(helpers.publicDashboard.handlePasswordChange)
    },
    on: {
      rowDetailsVisibilityChange: helpers.publicDashboard.handleRowDetailsVisibilityChange
    }
  })), /* @__PURE__ */ jsx("footer", {
    sel: ".modal-actions"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".public-dashboard-back-button",
    attrs: {
      elref: `publicDashboardDetailsBackButton`,
      theme: ButtonTheme.Secondary
    },
    on: {
      click: () => helpers.publicDashboard.updateSharingModalViewType(SharingModalViewType.Sharing)
    }
  }, "Back"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".public-dashboard-done-button",
    attrs: {
      theme: ButtonTheme.Primary
    },
    on: {
      click: helpers.publicDashboard.handlePublicDashboardDoneClick
    }
  }, "Done")));
};
export function template() {
  const {
    pendingCanEdit,
    pendingGrants,
    searchText,
    showCopyLinkText,
    showPopover,
    publicDashboardEnabled,
    modalViewType
  } = this.state;
  const projectMemberCount = this.helpers.getProjectMemberCount();
  const showDisabledBanner = this.attr(`disabled`) && this.attr(`disabled-reason`) && !this.helpers.shouldShowUpsellBanner();
  const showSuperadminBanner = this.attr(`is-superadmin`) && !this.helpers.shouldShowUpsellBanner();
  return /* @__PURE__ */ jsx(ModalEl, {
    attrs: {
      closeable: true,
      "modal-title": `Share this ${this.helpers.getEntityTypeTitle()} With Others`,
      "modal-description": `Modal for managing sharing permissions`,
      open: this.attr(`open`)
    }
  }, modalViewType === SharingModalViewType.PublicDashboardDetails ? /* @__PURE__ */ jsx(PublicDashboardDetailsView, {
    state: this.state,
    helpers: this.helpers,
    showSuperadminBanner
  }) : /* @__PURE__ */ jsx("div", {
    sel: `.wrapper`,
    class: {
      "no-min-height": this.helpers.shouldShowUpsellBanner(),
      "with-banner": showDisabledBanner || showSuperadminBanner
    }
  }, /* @__PURE__ */ jsx("header", {
    sel: ".modal-header"
  }, "Share this ", this.helpers.getEntityTypeTitle()), /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, showDisabledBanner ? /* @__PURE__ */ jsx(BannerEl, {
    style: { "margin-bottom": `20px` },
    attrs: {
      "body-text": this.attr(`disabled-reason`),
      theme: BannerTheme.Info,
      type: BannerType.Embedded
    }
  }) : null, showSuperadminBanner ? /* @__PURE__ */ jsx(BannerEl, {
    style: { "margin-bottom": `20px` },
    attrs: {
      "body-text": `You have not been granted access to edit this ${this.helpers.getEntityTypeTitle()}, but as a Project Owner you can make changes.`,
      theme: BannerTheme.Info,
      type: BannerType.Embedded
    }
  }) : null, this.helpers.showExistingSharesSection() ? /* @__PURE__ */ jsx(null, null, this.helpers.shouldShowUpsellBanner() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(BannerEl, {
    attrs: {
      elref: `upsellBanner`,
      theme: BannerTheme.Info,
      type: BannerType.Embedded,
      "body-text": `On your current plan, ${currentProjectStore.value.eventsPlanName}, everything you create is visible and editable by others in the project. Upgrade your plan to gain access to advanced sharing and additional privacy controls.`,
      ctas: [
        {
          text: `Upgrade`,
          actionName: BannerAction.Upgrade,
          icon: `share`,
          theme: ButtonTheme.Tertiary,
          href: `/pricing`
        }
      ]
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".existing-shares",
    attrs: { elref: `existingShares` },
    key: "existing-shares",
    class: {
      "viewer-state": this.attr(`disabled`)
    }
  }, ShareSection(`People`, null, this.helpers, true))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".picker-wrapper",
    key: "wrapper",
    hook: {
      insert: ({ elm }) => this.setElmRef(`tagInputWrapper`, elm)
    }
  }, /* @__PURE__ */ jsx("label", {
    attrs: { for: `picker` }
  }, "Invite Teammates"), /* @__PURE__ */ jsx("div", {
    sel: ".picker-controls"
  }, /* @__PURE__ */ jsx(TagInputEl, {
    attrs: {
      id: `picker`,
      tags: this.helpers.picker.getTags(),
      elref: `sharingTagInput`,
      placeholder: `Enter People or Team Names...`,
      "min-tags": 0,
      "disable-input": this.attr(`disabled`),
      "mp-select-attrs": {
        "disable-search": true,
        sections: this.helpers.getSelectOptions(ShareOptionsLocation.PickerControls),
        "menu-width": 120,
        "selected-option": pendingCanEdit ? `Editor` : `Viewer`,
        theme: SelectTheme.Tertiary,
        "always-show-caret": true,
        elref: `selectShareLevel`,
        disabled: this.attr(`disabled`)
      }
    },
    on: {
      change: this.helpers.picker.handleInputChange,
      focus: this.helpers.picker.handleInputFocus,
      optionSelected: this.helpers.picker.handleLevelSelectChange
    },
    hook: {
      insert: this.helpers.picker.handleMpTagInputInsert
    }
  }), /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: !!searchText && showPopover,
      "prevent-close-selectors": [`mp-tag-input`]
    },
    hook: {
      insert: ({ elm }) => this.setElmRef(`dropMenu`, elm)
    },
    on: {
      change: this.helpers.picker.handlePopoverChange
    }
  }, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      "search-filter": searchText,
      "empty-message": `This list is empty`,
      elref: `usersAndTeamsMenu`
    },
    props: {
      sections: this.helpers.picker.getMenuSections(),
      keydownProxyEl: this.elmRefs.tagInput
    },
    on: {
      clickItem: this.helpers.picker.handleItemClick
    }
  })), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".save-share",
    attrs: {
      disabled: pendingGrants.size === 0,
      elref: `saveNewSharesButton`,
      size: ButtonSize.Large,
      theme: ButtonTheme.Primary
    },
    on: {
      click: this.helpers.picker.handleShareButtonClick
    }
  }, "Share"))), /* @__PURE__ */ jsx("div", {
    sel: ".existing-shares",
    attrs: { elref: `existingShares` },
    key: "existing-shares",
    class: {
      "viewer-state": this.attr(`disabled`)
    }
  }, ShareSection(
    `People`,
    this.helpers.existingShares.getUserGrants(),
    this.helpers,
    this.attr(`disabled`)
  ), ShareSection(
    `Teams`,
    this.helpers.existingShares.getTeamGrants(),
    this.helpers,
    this.attr(`disabled`)
  )))) : /* @__PURE__ */ jsx("div", {
    sel: ".placeholder"
  }, /* @__PURE__ */ jsx("span", null, "Loading current shares..."), /* @__PURE__ */ jsx(SpinnerEl, null))), this.helpers.showProjectShareSection() ? /* @__PURE__ */ jsx("div", {
    sel: ".share-section--project",
    attrs: { elref: `shareSectionProject` }
  }, /* @__PURE__ */ jsx("header", null, this.helpers.publicDashboard.showPublicDashboardSwitch() ? `Advanced` : `Project`), /* @__PURE__ */ jsx("ul", {
    sel: ".share-list"
  }, /* @__PURE__ */ jsx("li", {
    sel: ".project-share"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".display"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".name-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".project-name"
  }, this.helpers.getProjectShareLabel()), !this.helpers.shouldShowUpsellBanner() && /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: {
      theme: `success`,
      text: this.helpers.getProjectShareGrantStatus()
    }
  })), this.attr(`disabled`) || this.helpers.publicDashboard.showPublicDashboardSwitch() ? null : /* @__PURE__ */ jsx("div", {
    sel: ".subtitle"
  }, `${projectMemberCount} ${pluralize(
    `person`,
    projectMemberCount,
    `people`
  )}`)), /* @__PURE__ */ jsx("div", {
    sel: ".controls"
  }, /* @__PURE__ */ jsx(SelectEl, {
    sel: ".share-level",
    attrs: {
      "disable-search": true,
      "menu-width": 120,
      theme: SelectTheme.Tertiary,
      "always-show-caret": true,
      sections: this.helpers.getSelectOptions(ShareOptionsLocation.ProjectShare),
      "selected-option": this.helpers.getProjectShareSelectOption(),
      elref: `selectShareLevel_${this.attr(`project-id`)}`,
      disabled: this.attr(`disabled`)
    },
    on: {
      change: this.helpers.handleProjectShareSelectChange
    }
  }))), this.helpers.publicDashboard.showPublicDashboardSwitch() ? /* @__PURE__ */ jsx("li", {
    sel: ".project-share"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".display"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".name-wrapper",
    class: { disabled: !this.helpers.publicDashboard.projectHasFeatureEnabled() }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".project-name"
  }, `Make Board Public`, "\xA0"), this.helpers.hasWorkspacesFeatureGate() ? /* @__PURE__ */ jsx("div", {
    sel: ".workspace-name"
  }, `via ${truncate(
    this.helpers.getCurrentWorkspaceName(),
    60
  )}`) : null, !this.helpers.publicDashboard.projectHasFeatureEnabled() && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info`, elref: `disabledInfoIcon` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: `Share boards with others outside your project. 
 Project Owners can enable Public Boards. 

 [Enable Public Boards](/settings/project/${currentProjectStore.value.id}/public-dashboards)`,
      placement: Placement.Right,
      elref: `disabledTextTooltip`
    }
  })))), /* @__PURE__ */ jsx("div", {
    sel: ".controls"
  }, !this.helpers.publicDashboard.canToggleFreePublicDashboards() && !this.helpers.projectHasIntegrated() && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: `Your project has no data! Start sending events today to share this board publicly.`,
      placement: Placement.Top,
      elref: `disabledToggleTooltip`
    }
  }), /* @__PURE__ */ jsx(SwitchEl, {
    sel: ".public-dashboard-switch",
    attrs: {
      on: publicDashboardEnabled,
      disabled: this.helpers.isSharingEnabledForProject() && this.attr(`disabled`) || !this.helpers.isSharingEnabledForProject() && !this.helpers.publicDashboard.canToggleFreePublicDashboards() || !this.helpers.publicDashboard.projectHasFeatureEnabled(),
      elref: `publicDashboardSwitch`
    },
    on: {
      change: this.helpers.publicDashboard.handlePublicDashboardSwitchChange
    }
  }))) : null)) : null, /* @__PURE__ */ jsx("footer", {
    sel: ".modal-actions"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".copy-link-button-wrapper"
  }, /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: `Copy the current URL`
    }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".copy-link-button",
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: this.helpers.shouldShowCopyLinkSpinner() ? `spinner` : `link`,
      disabled: this.helpers.shouldShowCopyLinkSpinner()
    },
    on: {
      click: this.helpers.shortUrl.handleCopyLinkClick
    }
  }, "Copy URL"), showCopyLinkText ? /* @__PURE__ */ jsx("input", {
    sel: ".copy-link-input",
    attrs: { type: `text`, readonly: true },
    hook: { insert: ({ elm }) => this.helpers.handleCopyLinkInputInsert(elm) },
    on: { click: this.helpers.handleCopyLinkInputClick }
  }) : null), !showCopyLinkText && !this.helpers.publicDashboard.showPublicDashboardSwitch() && !this.helpers.shouldShowUpsellBanner() ? /* @__PURE__ */ jsx("span", {
    sel: ".link-info"
  }, "Project members with this URL can view") : null, this.helpers.publicDashboard.showPublicDashboardSwitch() && this.helpers.publicDashboard.projectHasFeatureEnabled() && this.helpers.publicDashboard.canToggleFreePublicDashboards() ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".public-dashboard-detail-button",
    attrs: {
      elref: `publicDashboardDetailsButton`,
      theme: ButtonTheme.Tertiary,
      icon: `settings`
    },
    on: {
      click: () => this.helpers.publicDashboard.updateSharingModalViewType(
        SharingModalViewType.PublicDashboardDetails
      )
    }
  }, "Public Board Details") : null)));
}
